export default class UrlControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.input = document.createElement('input')
    this.input.id = window.PRIM.getUUID()
    this.input.value = args.value ? args.value : ''
    this.input.type = 'url'
    this.input.autocapitalize = 'off'
    this.input.autocorrect = 'off'
    this.input.spellcheck = 'false'
    this.input.disabled = args.readonly ? 'disabled' : ''
    this.input.onchange = args.onchange
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.input.id

    let onclick = () => {
      if (this.input.value) {
        let parsedUrl = this.input.value.trim()

        if (parsedUrl) {
          open(parsedUrl)
        }
      }
    }

    let button = document.createElement('button')
    button.className = 'icon'
    button.innerHTML = '\ue06d'
    button.onclick = onclick

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    div.appendChild(this.label)
    div.appendChild(this.input)
    div.appendChild(button)

    element.appendChild(fragment)
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.input.value ? this.input.value : null
  }

  setValue (value) {
    this.input.value = value
  }
}


// WEBPACK FOOTER //
// ./js/lib/ui/UrlControl.js